import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var dev = process.env.NEXT_PUBLIC_VERCEL_ENV === "development";
/**
 * Generates the path based on params.slug of GetStaticPropsContext
 * @param slug
 * @returns
 */

export var generatePath = function generatePath(slug, variant) {
  if (variant === void 0) {
    variant = process.env.NEXT_PUBLIC_VARIANT;
  }

  if (!slug || typeof slug === "string" || slug.length === 0) {
    slug = [];
  }

  if (variant) {
    slug.unshift(variant);
  } else {
    variant = slug[0];
  } // join the slug array used in Next.js catch-all routes


  return {
    slug: slug.join("/"),
    variant
  };
};
/**
 * Generates and cleans storyblok paths from /cdn/links
 * @param data
 * @returns array of paths to statically generate pages
 */

export var generatePaths = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (data, variant) {
    if (variant === void 0) {
      variant = process.env.NEXT_PUBLIC_VARIANT;
    }

    var paths = []; // create a routes for every link

    Object.keys(data.links).forEach(linkKey => {
      var {
        is_folder,
        slug
      } = data.links[linkKey];

      if (is_folder) {
        return;
      }

      slug = slug.replace(variant + "/", "");
      slug = slug.replace("home", ""); // do not create a route for folders or the home (index) page

      if (/^(global)/.test(slug)) {
        return;
      } // do not create a route for Modals for production


      if (!dev && /^(modal)/.test(slug)) {
        return;
      } // do not create a route for tests content for production


      if (!dev && /^(tests)/.test(slug)) {
        return;
      } // do not create a route for layout content for production


      if (!dev && /(layout)/.test(slug)) {
        return;
      } // do not create a route for 404 not found page


      if (/^(.*404)/.test(slug)) {
        return;
      } // get array for slug because of catch all
      // cretes all the routes


      var path = slug.split("/").filter(p => p);
      paths.push({
        params: {
          slug: path
        }
      });
    });
    return paths;
  });

  return function generatePaths(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Cleans a given href object from storyblok
 * @param href
 * @returns cleaned string
 */

export var cleanHref = function cleanHref(href, variant) {
  if (variant === void 0) {
    variant = process.env.NEXT_PUBLIC_VARIANT;
  }

  if (!href) return "";
  var url = "";

  if (typeof href === "string") {
    url = href; // If the link is an email we want to return early with the mailto: href.
  } else if (href.linktype === "email") {
    return "mailto:" + (href.cached_url || href.url || href.email);
  } else {
    if (!href.cached_url && !href.url) return "";
    url = href.cached_url || href.url;
  }

  if (url.startsWith("http")) {
    return url;
  } // remove the first "/" from the URL


  if (url.startsWith("/")) {
    url = url.slice(1);
  } // if a variant is detected, slice the variant


  if (variant) {
    if (url.startsWith(variant)) {
      url = url.slice(variant.length);
      return url;
    }
  } // re-add the "/" to confirm with href standards


  return "/" + url;
};
//# sourceMappingURL=utils.js.map